import { cloneDeep, isEqual } from 'lodash';

import BaseDropdown from './dropdown';

class PartnerDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = this.props.orgType || 'merchants';
    this.dropdownLabel = this.props.dropdownLabel || 'Merchants';
    // List item can be targeted by the merchant slug, e.g. $('.dropdown-item.macys')
    this.identifierField = 'slug';
    this.hasSearch = true;

    this.state = {
      merchants: this.props.items,
      publishers: this.props.items,
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
      ...(this.props.statType === 'merch-ed-overview' && {
        label: 'Search for a merchant...',
        activeOnly: this.props.activeOnly,
        reconciledOnly: this.props.reconciledOnly,
      }),
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.items, this.props.items) ||
      prevProps.activeOnly !== this.props.activeOnly ||
      prevProps.reconciledOnly !== this.props.reconciledOnly
    ) {
      const partners = this.getSelectedPartners(this.props.items);
      this.setState({
        [this.type]: partners,
        ...(this.props.statType !== 'merch-ed-overview' && {
          label: this.getLabel(this.props.items),
        }),
        ...(this.props.statType === 'merch-ed-overview' && {
          activeOnly: this.props.activeOnly,
          reconciledOnly: this.props.reconciledOnly,
        }),
      });
    }
  }

  update() {
    const partners = this.getSelectedPartners(this.state[this.type]);

    this.setState(
      {
        [this.type]: partners,
        ...(this.props.statType !== 'merch-ed-overview' && {
          label: this.getLabel(partners),
        }),
      },
      () => {
        if (this.props.statType === 'merch-ed-overview') {
          const { activeOnly, reconciledOnly } = this.state;
          this.props.updateMerchantParams(partners, activeOnly, reconciledOnly);
        } else if (this.props.statType === 'insights') {
          const resetCarousel = partners.length === partners.filter(merch => merch.selected).length;
          this.props.updatePartners(partners, false, resetCarousel);
        } else {
          this.props.updatePartners(partners);
        }

        const orgId = this.type === 'Publishers' ? 'pub_id' : 'merch_id';
        const partnerIds = partners.filter(p => p.selected).map(p => p[orgId]);
        this.AnalyticService.trackEvent(
          this.props.gaEvent.category,
          'Execute',
          `${this.props.gaEvent.label} ${partnerIds.join(',')}`,
        );
      },
    );
  }

  resetColumns(selectedState) {
    // Create deep copy to prevent mutating state object directly
    let partners = cloneDeep(this.state[this.type]);
    partners = partners
      .filter(partner => !partner.hidden)
      .map(partner => {
        partner.selected = selectedState;
        return partner;
      });
    this.setState({ [this.type]: partners });
  }

  getSelectedPartners(partners) {
    let newPartners = cloneDeep(partners);
    // If no merchants selected, select all merchants instead
    if (newPartners && !newPartners.filter(partner => partner.selected).length) {
      newPartners = newPartners.map(partner => {
        partner.selected = true;
        return partner;
      });
    }

    return newPartners;
  }

  getLabel(partners) {
    let totalPartners = 0; // Count non-hidden merchants
    let numSelected = 0;
    let label;
    partners.forEach(partner => {
      if (partner.selected) numSelected += 1;
      if (!partner.hidden) totalPartners += 1;
    });

    if (numSelected === 0 || numSelected === totalPartners) {
      label = `All ${this.dropdownLabel}`;
    } else if (numSelected === 1) {
      label = partners.find(merch => merch.selected).label;
    } else {
      label = `${numSelected} ${this.dropdownLabel}`;
    }

    return label;
  }
}

export default PartnerDropdown;
